import { useState } from 'react'
import s from './Sidebar.scss'
import cn from 'classnames'
import { FaCaretRight, FaCaretDown } from 'react-icons/fa'
import { DraggableBlock } from './DraggableBlock'
import { fromReactComponentToHtmlDocument, sortAlphabetically } from 'utils/helpers'
import { Button } from 'reactstrap'

const Sidebar = ({ pageType, categories, htmlTemplate, actions, pages }) => {
  const [openedCategories, setOpenedCategories] = useState([])

  const toggleCategory = category => {
    if (openedCategories.includes(category)) {
      const index = openedCategories.findIndex(c => c === category)
      const array = [...openedCategories]
      array.splice(index, 1)
      setOpenedCategories(array)
    } else {
      setOpenedCategories([...openedCategories, category])
    }
  }

  return (
    <div className={cn(s.sidebarWrapper, s[pageType])}>
      {actions?.length > 0 && (
        <div className={s.actionBtnsWrapper}>
          {actions.map((button, index) => (
            <Button
              key={index}
              className={cn({
                [button.className]: button.className
              })}
              onClick={() => {
                button.cb(pages, fromReactComponentToHtmlDocument(htmlTemplate.current.outerHTML))
              }}
              disabled={button.enabled !== undefined ? !button.enabled : false}
            >
              {button.text}
            </Button>
          ))}
        </div>
      )}
      <p className={s.title}>Add Blocks To Proposal</p>
      <p className={s.subtitle}>
        Click on a category and drag-n-drop block on your Proposal page on the left
      </p>
      <div className={s.wrapper}>
        {Object.keys(categories)
          .sort()
          .map(category => {
            if (!categories[category].length) return null
            return (
              <div key={category}>
                <p onClick={() => toggleCategory(category)} className={s.category}>
                  {openedCategories.includes(category) ? <FaCaretDown /> : <FaCaretRight />}
                  {category}
                </p>
                <>
                  {openedCategories.includes(category) && (
                    <>
                      {sortAlphabetically(categories[category], 'name').map(block => (
                        <DraggableBlock key={block.id} block={block} category={category} />
                      ))}
                    </>
                  )}
                </>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default Sidebar
